import React from "react";
import {
  FormControl,
  OutlinedInput,
  InputAdornment,
  FormHelperText,
  Typography,
} from "@mui/material";
import PropTypes from "prop-types";

import theme from "../../theme"

const FormInput = ({
  inputLabel,
  placeholder,
  type,
  icon,
  onChange,
  name,
  value,
  error,
  classes,
  isRequired,
  maxLength,
  minLength,
  handleKeyPress,
  style,
  multiline,
  rows,
  endIcon,
  handleKeyDown,
  clearIcon,
  handleRemoveSearch,
  handleKeyUp,
  disabled
}) => {
  return (
    <FormControl variant="standard" style={style} sx={{ margin: "0px 5px" }}>
      {inputLabel && (
        <>
          <Typography className="field-label">
            {inputLabel}
            {isRequired && <span className="helper-text"> *</span>}
          </Typography>
        </>
      )}
      <OutlinedInput
        placeholder={placeholder}
        className={`input-box ${classes}`}
        type={type}
        name={name}
        value={value}
        multiline={multiline}
        rows={rows}
        onChange={onChange}
        onKeyPress={handleKeyPress}
        onKeyDown={handleKeyDown}
        onKeyUp={handleKeyUp}
        error={error ? true : false}
        disabled={disabled}
        // inputProps={{ maxLength: maxLength, minLength: minLength }}
        sx={{
          margin: "0px",
          Input: {
            "&.Mui-disabled": {
              WebkitTextFillColor: theme.palette.primary.darkGray,
            },
          },
        }}
        startAdornment={
          <>
            {icon && (
              <InputAdornment
                position="start"
                sx={{
                  padding: "0px 0px !important",
                }}
              >
                {icon ? icon : ""}
              </InputAdornment>
            )}
          </>
        }
        endAdornment={
          <>
            {<InputAdornment
                position="start"
                sx={{
                  padding: "0px 0px !important",
                  cursor: "pointer",
                  width:"18px",
                  height:"18px"
                }}
                onClick={handleRemoveSearch}
              >
                {clearIcon}
              </InputAdornment>}
            {endIcon && (
              <InputAdornment
                position="end"
                sx={{
                  padding: "0px 0px !important",
                }}
              >
                
                {endIcon ? endIcon : ""}
              </InputAdornment>
            )}
          </>
        }
      />
      <FormHelperText error className={`helper-text`}>
        {error}
      </FormHelperText>
    </FormControl>
  );
};

FormInput.prototype = {
  inputLabel: PropTypes.string,
  placeholder: PropTypes.string,
  type: PropTypes.any,
  icon: PropTypes.object,
  onChange: PropTypes.func,
  name: PropTypes.string,
  value: PropTypes.string,
  id: PropTypes.string,
  helperText: PropTypes.any,
  error: PropTypes.any,
  classes: PropTypes.any,
  isRequired: PropTypes.any,
  minLength: PropTypes.number,
  maxLength: PropTypes.number,
  handleKeyPress: PropTypes.func,
  style: PropTypes.any,
  multiline: PropTypes.bool,
  rows: PropTypes.number,
  endIcon: PropTypes.any,
  handleKeyDown: PropTypes.func,
  clearIcon: PropTypes.any,
  handleRemoveSearch: PropTypes.func,
  handleKeyUp: PropTypes.func,
  disabled:PropTypes.any
};
export default FormInput;
